<div class="field mb-4">
  <!-- Start::título -->
  <span class="text-900 text-2xl block font-semibold mb-5">
    ¿Dónde y cuándo quieres recibir tu pedido?
  </span>
  <!-- End::título -->

  <!-- Start::dirección seleccionada -->
  <div
    class="flex p-4 mt-3 lg:mt-0 mb-4 border-round border-1 w-full flex align-items-center justify-content-between min-h-6rem"
    [ngClass]="
      areLoadingAddresses()
        ? 'surface-border'
        : isInvalidSelectedAddressInput()
        ? 'border-danger bg-red-50 cursor-pointer'
        : 'border-primary bg-blue-50 cursor-pointer'
    "
    (click)="sidebar.show()"
  >
    @if(areLoadingAddresses()){
    <!-- Start::skeleton de carga de dirección seleccionada -->
    <div class="flex flex-column gap-2">
      <p-skeleton width="14rem" />
      <p-skeleton width="24rem" />
    </div>
    <p-skeleton width="2rem" styleClass="ml-auto" />
    <!-- End::skeleton de carga de dirección seleccionada -->

    } @else {
    <!-- Start::card de dirección seleccionada o sin seleccionar -->
    <div class="flex flex-column gap-1">
      <div class="font-semibold" [ngClass]="{ uppercase: selectedAddress() }">
        {{
          selectedAddress()
            ? selectedAddress()?.address
            : 'Debes agregar una dirección'
        }}
      </div>
      <span class="text-sm">{{
        selectedAddress() ? selectedAddress()?.city : 'Este campo es requerido'
      }}</span>
    </div>
    <i class="fa-sharp fa-solid fa-angle-right text-xl ml-auto"></i>
    <!-- End::card de dirección seleccionada o sin seleccionar -->
    }
  </div>
  <!-- End::dirección seleccionada -->

  <!-- Start::sidebar para seleccionar dirección -->
  <app-address-list-sidebar
    #sidebar
    [addresses]="addresses()"
    [selectedAddressId]="selectedAddress()?.id || null"
    (onSubmit)="onSelectAddress($event)"
  />
  <!-- End::sidebar para seleccionar dirección -->
</div>
